import { useState } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import BuildIcon from '@material-ui/icons/Build';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';

import useMaintenanceAlertQuery from 'hooks/queryHooks/useMaintenanceAlertQuery';

const useStyles = makeStyles(() => ({
  appBar: {
    backgroundColor: '#FFF4E5',
    color: 'black',
    boxShadow: 'none',
    borderBottom: '1px solid lightgray',
  },
  toolbar: {
    display: 'flex',
  },
  message: {
    display: 'flex',
    flexGrow: 1,
  },
  icon: {
    marginRight: 12,
    marginTop: 2,
  },
}));

const MaintenanceAlert = () => {
  const classes = useStyles();
  const [visible, setVisible] = useState(true);
  const { data: maintenanceAlert } = useMaintenanceAlertQuery();

  if (!visible || !maintenanceAlert?.enabled) {
    return null;
  }

  return (
    <AppBar position="sticky" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <div className={classes.message}>
          <BuildIcon className={classes.icon} />
          <Typography variant="body1" color="inherit" gutterBottom>
            Scheduled Maintenance: {maintenanceAlert.message}
          </Typography>
        </div>
        <IconButton edge="end" color="inherit" onClick={() => setVisible(false)} aria-label="close">
          <CloseIcon />
        </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default MaintenanceAlert;
